import { Divider, FormControl, TextField } from '@mui/material';
import SelectElement from 'components/SelectElement';
import { getVehiclesSelector } from 'features/Vehicles';
import { shallowEqual, useSelector } from 'react-redux';

const ManualFields = ({ selectedVehicle, setSelectedVehicle, odometerValue, setOdometerValue }) => {
  const availableVehicles = useSelector((state) => getVehiclesSelector(state), shallowEqual);

  return (
    <>
      <Divider className="my-3" />
      <h4 className="mb-3">Identificación manual del vehículo</h4>
      <SelectElement
        className="mb-3 align-items-center justify-content-between"
        selectedId={selectedVehicle ? selectedVehicle.number_plate : ''}
        idAttribute="number_plate"
        optionLabel="number_plate"
        label="Vehículo"
        options={Object.values(availableVehicles)}
        onChange={(selectedVehicle) =>
          setSelectedVehicle(
            Object.values(availableVehicles).find(
              (vehicle) => vehicle.number_plate === selectedVehicle
            )
          )
        }
        defaultValue="Seleccione un vehículo"
      />
      <div className="select-element-container d-flex flex-row mb-3 align-items-center justify-content-between">
        <span className="subtitle mr-2 w-75">Odómetro del vehículo (km)</span>
        <FormControl className="connector-select-form">
          <TextField
            required
            label="Odometer value"
            type="number"
            value={odometerValue}
            size="small"
            className="text-center hide-label"
            variant="outlined"
            onChange={(event) => setOdometerValue(event.target.value)}
            InputLabelProps={{
              shrink: false,
            }}
            hiddenLabel={true}
            helperText={
              <span>
                Último odómetro:
                {` ${
                  selectedVehicle &&
                  selectedVehicle.latest_transaction &&
                  selectedVehicle.latest_transaction.odometer
                    ? `${parseFloat(selectedVehicle.latest_transaction.odometer) / 1000} km`
                    : '- - -'
                }`}
              </span>
            }
          />
        </FormControl>
      </div>
      {selectedVehicle &&
      selectedVehicle.latest_transaction &&
      selectedVehicle.latest_transaction.odometer &&
      odometerValue &&
      parseFloat(odometerValue) < parseFloat(selectedVehicle.latest_transaction.odometer) / 1000 ? (
        <span className="text-warning font-size-12">
          El odómetro ingresado es menor que el último odómetro del vehículo. Podrá iniciar carga de
          todas formas pero la decisión queda bajo su propia responsabilidad.
        </span>
      ) : null}
    </>
  );
};

export default ManualFields;
